export * from './archivieren-post-request.interface';
export * from './archivieren-post-response.interface';
export * from './archivieren-post.shapes';
